export const LotURLs = {
    singleLotEditForm: "/subdivisions/:subdivisionId/lots/:lotId/edit",
    bulkLotAddForm: "/subdivisions/:subdivisionId/lots/bulkAdd",
    bulkLotEditForm: "/subdivisions/:subdivisionId/lots/bulkEdit",
    singleLotAddForm: "subdivisions/:subdivisionId/lots/add",
    lotDetailView: "/subdivisions/:subdivisionId/lots/:lotId",
}